import { MenuItem } from "@mui/material";

export const genGetLabel = (dic, def) => ( (id) => dic[id] ? dic[id] : dic[def] );
// `keys` (strings, as Object.keys returns them) sets the listing order. Without it,
// integer-like keys always come out in ascending numeric order, whatever the insertion order.
export const genOptions = (dic, keys = Object.keys(dic)) => ( keys.map( (k) => ({ id: k, name: dic[k] }) ));
export const genGridOptions = (dic, keys = Object.keys(dic)) => ( keys.map( (k) => ({ value: k, label: dic[k] }) ));
export const genHtmlOptions = (dic, disabled = {}, keys = Object.keys(dic)) => ( keys.map( (k) => (<option key={k} value={k} {...( disabled && disabled[k] ? { disabled: true } : {} ) }>{dic[k]}</option>)) );
export const genMenuItems = (dic, keys = Object.keys(dic)) => ( keys.map( (k) => <MenuItem key={k} value={k}>{dic[k]}</MenuItem>) );
export const objectListToMenuItems = (list, opts) => (
    (list || [])
        .concat(
            [ opts && opts.empty ? { id: '', name: opts.empty } : null ].filter( (c) => (c!==null) )
        )
        .map( (c) => (
            <MenuItem
                key={opts && opts.key ? c[opts.key] : c.id} 
                value={opts && opts.value ? c[opts.value] : c.id}
                {...(opts && opts.attrs ? opts.attrs : {})}
                >
                    {opts && opts.name && c[opts.name] ? (typeof c[opts.name] === "function" ? c[opts.name](c, opts) : c[opts.name]) : c.name}
            </MenuItem>
    ))
)
